// extracted by mini-css-extract-plugin
export default {"page":"z0-z","cartModal":"A0-z","checkout":"B0-z","placeholder":"C0-z","account":"D0-z"};